export const getSelectedTemplate = (templatesList = [], selectedTemplateTitle) =>
  templatesList.find(({ slug }) => selectedTemplateTitle === slug);
